import { observer } from "mobx-react";
import React from "react";
import classnames from "classnames";

import { Button } from "@components/buttons";

import { SportStatisticsTypeEnum } from "@data-types/analytics-tracker/SportsStatisticsInteractionTypeEnum";
import { BettingType, EventKey, EventKeyBettingOffer } from "@gp/models";
import { OfferStore } from "@state/context/offer/OfferContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { analyticsTracker } from "@utils/analytics";
import { TStatisticsBettingData } from "@data-types/offer/event-betting-type/StatisticsBettingData";

export default observer(function BettingTypeStatisticsButton(props: {
	bettingType: BettingType;
	setToggleState: Function;
	toggleState: TStatisticsBettingData | null;
	offerKey: { id: string } | EventKey[];
}) {
	const store = useOfferContext<OfferStore.EventViewStore>();

	const keyOffersMap = store.keyOffersMap;

	//@ts-expect-error
	const keyOffers = keyOffersMap.get(props.offerKey.id);
	let offers: EventKeyBettingOffer[] = [];
	if (keyOffers != null) {
		offers = Array.from(keyOffers.values());
	}

	const playerIds = offers.map((offer) => offer.playerId);

	if (
		!store.sportStatisticsStore.availableBTypesSet.has(
			props.bettingType.abrv
		)
	) {
		return null;
	}

	return (
		<Button
			className={classnames(
				"btn--square btn--square--tny btn--icon btn--ghost offer--additional__btn"
			)}
			onClick={async (e) => {
				e.preventDefault();
				e.stopPropagation();

				if (!props.toggleState?.data) {
					const data =
						await store.sportStatisticsStore.fetchBettingStats(
							props.bettingType,
							/* @ts-expect-error */
							props.offerKey,
							playerIds
						);
					if (!data) {
						props.setToggleState(null);
					} else {
						props.setToggleState("stats", data);
						analyticsTracker.trackSportStatisticsInteractionTracking(
							SportStatisticsTypeEnum.BettingTypeStatistics
						);
					}
				} else {
					props.setToggleState(null);
				}
			}}
			iconLeft
			iconClassName={classnames("u-icon--sml", {
				"u-icon--action--stats-additional--selected":
					props.toggleState?.action == "stats",
				"u-icon--action--stats-additional--active":
					props.toggleState?.action != "stats",
			})}
		/>
	);
});
